export default __webpack_public_path__ + "static/media/loading_icon.42aaa181.jpeg";